import { Template } from '@/core/architecture'

import type { EmailAddressFormProps } from './EmailAddressInputForm'
import type { EmailAddressFormSNSProps } from './EmailAddressInputFormSNS'
import {
  EmailAddressInputSocialTemplate,
  EmailAddressInputTemplate,
} from './EmailAddressInputTemplate'
import { EmailAddressSettingCompleteModal } from './EmailAddressSettingCompleteModal'
import { EmailVerificationFormProps } from './EmailVerificationForm'
import { EmailVerificationTemplate } from './EmailVerificationTemplate'

export * from './fragments'

export type State = {
  step: number
  email: string
  isBoundWithSNS: boolean
  verifyEmailSending: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  sendVerificationMail: EmailAddressFormProps['onSubmit']
  sendVerificationMailSocial: EmailAddressFormSNSProps['onSubmit']
  resendVerificationMail: EmailVerificationFormProps['onResend']
  updateEmail: EmailVerificationFormProps['onSubmit']
  onCloseCompleteModal: () => void
}

export const EmailAddressSettingsTemplate: Template<State, Action> = ({
  state,
  sendVerificationMail,
  sendVerificationMailSocial,
  resendVerificationMail,
  updateEmail,
  onCloseCompleteModal,
}) => {
  if (state.isBoundWithSNS) {
    return (
      <EmailAddressInputSocialTemplate
        state={state}
        sendVerificationMailSocial={sendVerificationMailSocial}
      />
    )
  }

  return state.step === 0 ? (
    <EmailAddressInputTemplate
      state={state}
      sendVerificationMail={sendVerificationMail}
    />
  ) : (
    <>
      <EmailAddressSettingCompleteModal
        open={state.step === 2}
        onClose={onCloseCompleteModal}
      />
      <EmailVerificationTemplate
        state={state}
        onSubmit={updateEmail}
        onResend={resendVerificationMail}
      />
    </>
  )
}
